export default {
  title: "Proveedor POS"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , permitidos: {
      label: "Cantidad de SE/Seller permitidos"
      , th: "Permitidos"
    }
    , partners: {
      label: "Partners"
      , th: "Partners"
    }
  }
  , errors: {
    BD5021: { text: "Ocurrió un error en el catálogo de ProveedorPos" }
    , WS5021: { text: "Ocurrió un error en el catálogo de ProveedorPos" }
    , JS5021: { text: "Ocurrió un error en el catálogo de ProveedorPos" }
    , C55021: { text: "Ocurrió un error en el catálogo de ProveedorPos" }
    , UK_ProveedorPos: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/proveedorpos.js